import { RELEASE_ID } from 'dg-web-shared/common/utils/release.ts';
import { logActionShared } from 'dg-web-shared/lib/utils/ActionLog.ts';
import { UAParser } from 'ua-parser-js';

const agent = new UAParser().getResult();
const device = {
    ...agent,
    width:
        typeof window !== 'undefined' && typeof window.screen !== 'undefined'
            ? window.screen.width
            : 0,
    height:
        typeof window !== 'undefined' && typeof window.screen !== 'undefined'
            ? window.screen.height
            : 0,
};

export function logAction(
    name: string,
    operatorExternalId: string,
    payload: unknown = null,
): string {
    const url = `/ui-api/parkingabo/operator/${operatorExternalId}/flux-action`;
    const body = {
        action: name,
        payload: payload,
        device: device,
        appVersion: RELEASE_ID,
    };
    logActionShared(url, body, name);
    return 'logged-action';
}
